
export class User {
  displayName!: string;
  email!: string;
  eid!: string;
  roles!: string[];
}
